let hitID =null;
export const setHitID=(id)=>{
    hitID=id;
};
export const getHitID=()=>{
    return hitID;
}